module.exports = __webpack_public_path__ + "family_foliage_1.jpg";